import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import JssProvider from 'react-jss/lib/JssProvider';
import getMessages from '../lib/i18n/getMessages';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import client from '../lib/apolloClient';
import configureStore from '../store/findBobPublicStore';
import themes from '../lib/themes';
import SuccessionRolodex from '../components/Succession/SuccessionRolodex';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import SuccessionDrawerWithListener from './Succession/SuccessionDrawerWithListener';
import { CurrencyProvider } from '../hooks/useCurrency';

const SuccessionRolodexContainer = (props, railsContext) => {
  const initialState = {
    company: props.company || { 
      host: railsContext.company_host,
      features: railsContext.features,
      file_import_disclaimer: railsContext.file_import_disclaimer,
      name: railsContext.company_name,
      branded_name: railsContext.company_branded_name,
      short_name: railsContext.company_short_name,
      primary_color: railsContext.primary_color,
      secondary_color: railsContext.secondary_color,
      neutral_color: railsContext.neutral_color,
      accent_color: railsContext.accent_color,
      background_color: railsContext.background_color,
    },
    user: props.current_user,
  };

  const store = configureStore({ ...props, company: initialState.company });

  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'fbSuccession',
  });

  const jss = create({
    ...jssPreset(),
  });

  const theme = themes[railsContext && railsContext.theme_name];
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = railsContext && railsContext.currency;
  const locale = window.locale;
  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || 'USD'}>
      <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="fbSuccession-">
        <MuiThemeProvider theme={createMuiTheme(theme)}>
          <CssBaseline />
          <Provider store={store}>
            <SnackbarProvider maxSnack={5}>
              <ApolloProvider client={client}>
                <IntlProvider locale={locale} messages={getMessages(locale)}>
                <SuccessionThemeProvider
                  company={initialState.company}
                  user={props.current_user}
                >
                  <SuccessionRolodex
                    followingCount={props.following_count}
                    followersCount={props.followers_count}
                    userViews={props.user_views}
                    messagesCount={props.messages_count}
                    currentUser={props.current_user}
                    company={props.company}
                  />
                  <SuccessionDrawerWithListener />
                </SuccessionThemeProvider>
                </IntlProvider>
              </ApolloProvider>
            </SnackbarProvider>
          </Provider>
        </MuiThemeProvider>
      </JssProvider>
    </CurrencyProvider>
  );
};

export default SuccessionRolodexContainer;

